<template>
  <v-app>
    <v-container>
      <v-row v-if="firstScreen">
        <v-col class="py-0">
          <v-row>
            <v-col
              class="py-0  d-flex justify-center"
              offset-sm="4"
              sm="4"
            >
              <v-img
                contain
                height="80pt"
                width="100pt"
                :src="'data:image/jpg;base64,'+configuration.interface_description.first_screen.logo_base64"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center pb-1">
              <span :style="`color: ${configuration.interface_description.first_screen.text1.color};font-size: ${configuration.interface_description.first_screen.text1.size}px`">
                {{ configuration.interface_description.first_screen.text1.text }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center py-1">
              <span :style="`color: ${configuration.interface_description.first_screen.text2.color}; font-size: ${configuration.interface_description.first_screen.text2.size}px`">
                {{ this.configuration.interface_description.first_screen.text2.text }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="(planogramm, index) in configuration.planogramm "
              v-show="(planogramm.amount>0 && configuration.type==6) || (planogramm.price_cashless>0 && configuration.type==4)"
              :key="index"
              cols="6"
              sm="4"
            >
              <v-btn
                width="100%"
                :style="`color: ${configuration.interface_description.first_screen.buttons.text.color}; background-color: ${configuration.interface_description.first_screen.buttons.background}`"
                @click="onChooseItem(planogramm)"
              >
                {{ showOnTheButton(planogramm) }} {{ unitOfMeasure(configuration.interface_description.first_screen.buttons.label_type) }}
              </v-btn>
            </v-col>
            <v-col
              v-for="(planogramm, index) in configuration.planogramm "
              v-show="((planogramm.amount==0 || !planogramm.amount) && configuration.type==6) || (planogramm.price_cashless==0 && configuration.type==4)"
              :key="index + 'z'"
              cols="12"
            >
              <v-btn
                width="100%"
                :style="`color: ${configuration.interface_description.first_screen.buttons.text.color}; background-color: ${configuration.interface_description.first_screen.buttons.background}`"
                @click="onChooseItem(planogramm)"
              >
                {{ configuration.interface_description.first_screen.buttons.label }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--      SecondScreen-->
      <v-row v-if="secondScreen">
        <v-col>
          <v-row>
            <v-col class="text-center">
              <span :style="`color: ${configuration.interface_description.first_screen.text1.color};font-size: ${configuration.interface_description.first_screen.text1.size}px`">
                Введите количество
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="anyAmount"
                hide-details
                solo
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="(digit, idx) in [1,2,3,4,5,6,7,8,9]"
              :key="idx"
              cols="4"
              class="d-flex justify-center"
            >
              <v-btn
                :style="`color: ${configuration.interface_description.first_screen.buttons.text.color}; background-color: ${configuration.interface_description.first_screen.buttons.background}`"
                width="100%"
                @click="onAdd(digit)"
              >
                {{ digit }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              offset="4"
              cols="4"
              class="text-center"
            >
              <v-btn
                :style="`color: ${configuration.interface_description.first_screen.buttons.text.color}; background-color: ${configuration.interface_description.first_screen.buttons.background}`"
                width="100%"
                @click="onAdd(0)"
              >
                0
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                :style="`color: ${configuration.interface_description.first_screen.buttons.text.color}; background-color: ${configuration.interface_description.first_screen.buttons.background}`"
                width="100%"
                @click="onBackspace"
              >
                C
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
          <v-row>
            <v-col
              cols="6"
              class="text-center"
            >
              <v-btn
                color="error"
                @click="onCancel"
              >
                Отмена
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <v-btn
                color="success"
                @click="onOk"
              >
                Ввод
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- ErrorScreen -->
      <v-row v-if="errorScreen">
        <v-col>
          <v-row>
            <v-col>
              <v-img :src="'data:image/jpg;base64,'+configuration.interface_description.error_screen.logo_base64" />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="text-center"
              cols="12"
            >
              <span :style="`color:${configuration.interface_description.error_screen.text1.color};font-size:${configuration.interface_description.error_screen.text1.size}px`"> {{ configuration.interface_description.error_screen.text1.text }} </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              offset="4"
              cols="4"
            >
              <v-btn
                width="100%"
                :style="`color: ${configuration.interface_description.error_screen.buttons.text.color}; background-color: ${configuration.interface_description.error_screen.buttons.background}`"
                @click="onReloadWindow"
              >
                Назад
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-container>
  </v-app>
</template>
<script>
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
import { guid } from "@/views/loyalty/shared/modules/utilities"

export default {
  data: () => ({
    amountForPay: 0,
    anyAmount: "0",
    configuration: {},
    errorScreen: false,
    firstScreen: true,
    guid: null,
    nomenclatures: [],
    overlay: false,
    paymentService: null,
    planogramm: {},
    pointId: '',
    priceOfGoods: 0,
    secondScreen: false,
  }),
  async beforeMount () {
    this.paymentService = new JustpayPaymentSystemService()
    this.pointId = this.$route.query.id
    localStorage.setItem('pointId', this.pointId)
    console.log('pointId', this.pointId)
    const response = await this.paymentService.getEntities(this.pointId)
    console.log('response', response)
    if (!response.value.error) {
      console.log('Success!')
      this.configuration = response.value.data.configuration
      this.nomenclatures = response.value.data.nomenclatures
    }
  },
async mounted () {
  this.guid = guid()
},
methods: {
    // add digit to sum
  onAdd (item) {
    // if (this.anyAmount[0] == 0) { this.anyAmount = this.anyAmount.substring(1) }
    this.anyAmount = this.anyAmount.replace(/^0+/g, '')
    this.anyAmount = this.anyAmount + item
  },
  // remove digit from sum
  onBackspace () {
    const length = this.anyAmount.length
    this.anyAmount = this.anyAmount.substring(0, length - 1)
  },
  onCancel () {
    this.firstScreen = true
    this.secondScreen = false
  },
  // ready to pay
  async onChooseItem (planogramm) {
    this.planogramm = planogramm
    if (this.configuration.type == 4) {
      if (planogramm.price_cashless == 0) {
        this.firstScreen = false
        this.secondScreen = true
        this.errorScreen = false
        this.priceOfGoods = planogramm.price_cashless
      } else {
        this.amountForPay = planogramm.price_cashless
        console.log('this.amountForPay', this.amountForPay)
        const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        console.log('nomenclature', nomenclature)
        const items = [{
          name: nomenclature.name,
          count: 1,
          amount: this.amountForPay,
          price: this.amountForPay
        }]
        await this.startToPay(items, this.planogramm.nomenclature)
      }
    }
    if (this.configuration.type == 6) {
      if (planogramm.amount == 0 || !planogramm.amount) {
        this.firstScreen = false
        this.secondScreen = true
        this.errorScreen = false
        this.priceOfGoods = planogramm.price_cashless
      } else {
        this.amountForPay = planogramm.amount * planogramm.price_cashless
        console.log('this.amountForPay', this.amountForPay)
        const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        console.log('nomenclature', nomenclature)
        const items = [{
          name: nomenclature.name,
          count: this.planogramm.amount,
          amount: this.amountForPay,
          price: planogramm.price_cashless
        }]
        await this.startToPay(items, this.planogramm.nomenclature)
      }
    }
  },
  // ready to pay
  async onOk () {
    let items = []
    if (this.configuration.type == 4) {
      this.amountForPay = this.anyAmount
      console.log('this.amountForPay', this.amountForPay)
      const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
      console.log('nomenclature', nomenclature)
      items = [{
        name: nomenclature.name,
        count: 1,
        amount: this.amountForPay,
        price: this.amountForPay
      }]
    }
    if (this.configuration.type == 6) {
      this.amountForPay = this.anyAmount * this.priceOfGoods
      console.log('this.amountForPay', this.amountForPay)
      const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
      console.log('nomenclature', nomenclature)
      items = [{
        name: nomenclature.name,
        count: this.anyAmount,
        amount: this.amountForPay,
        price: this.priceOfGoods
      }]
    }
    await this.startToPay(items, this.planogramm.nomenclature)
  },
  showOnTheButton (planogramm) {
    let itemToShow = 0
    if (this.configuration.type == 4) {
      itemToShow = planogramm.price_cashless
    }
    if (this.configuration.type == 6) {
      itemToShow = planogramm.amount
    }
    return itemToShow
  },
  onReloadWindow () {
    window.location.reload()
  },
  async startToPay (items, nomenclatureId) {
    this.overlay = true
    const response = await this.paymentService.createPayment({ idempotency: this.guid, nomenclatureId: nomenclatureId, pointId: this.pointId, items: items, sum: this.amountForPay })
    this.overlay = false
    console.log('response for nspk', response)
    if (response.value.error) {
      this.firstScreen = false
      this.secondScreen = false
      this.errorScreen = true
      console.log('error', response.value.error)
    } else {
      this.firstScreen = true
      this.secondScreen = false
      const nspkLink = response.value.data.qr
      // window.open(nspkLink, '_blank')
      window.open(nspkLink, '_self')
    }
  },
  unitOfMeasure (type) {
    if (type == 0) return 'руб.'
    if (type == 1) return 'шт.'
  }
}
}
</script>

<style scoped>
.test {
  font-size: 10px;

}
</style>
